<template>
	<div class="information">
		<div class="container">
			<div class="informationlist">
				<h1>职位名称：Android工程师</h1>
				
				<div class="renzhiyaoqiu">
					<h2>任职要求：</h2>
					<p>1.精通Java语言</p>
					<p>2.精通Java语言</p>
					<p>3.较强的文档编写能力和设计能力</p>
					<p>4较强的文档编写能力和设计能力</p>
					<p>5.较强的文档编写能力和设计能力</p>
				</div>
				
				<div class="renzhiyaoqiu">
					<h2>岗位职责：</h2>
					<p>1.精通Java语言</p>
					<p>2.精通Java语言</p>
					<p>3.较强的文档编写能力和设计能力</p>
					<p>4较强的文档编写能力和设计能力</p>
					<p>5.较强的文档编写能力和设计能力</p>
				</div>
				
				<div class="email">
					<p>简历投递邮箱：job@tiantu.com欢迎自荐或推荐。更多招聘信息请关注：http://www.baidu.com</p>
					<p>加入天图极客大家庭，实现您心中的梦想</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		conponents:{},
		data(){
			return{
				msg:'information'
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
.information{
	margin-top: 70px;
	margin-bottom: 70px;
	.informationlist{
		width: 100%;
		height: 700px;
		border: 1px solid #ccc;
		padding: 60px;
		h1{
			font-size: 30px;
			margin-bottom: 25px;
		}
		.renzhiyaoqiu{
			margin-top: 30px;
			h2{
				font-size: 20px;
				margin-bottom: 5px;
			}
			p{
				padding: 7px;
				font-size: 17px;
			}
		}
		.email{
			margin-top: 30px;
			p{
				font-size: 16px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ContactUs/Ccom/Information.vue